
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Steve Ma",
  title: "Hi all, I'm Steve",
  subTitle: emoji("A passionate Software Developer 🚀 and a Computer Science student 💻"),
  resumeLink: "https://drive.google.com/file/d/15rm9fEPD3dOR732eB1apaqCHc84_Mkfl/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/mastevb",
  linkedin: "https://www.linkedin.com/in/steve-ma/",
  gmail: "bochenma@cs.washington.edu",
  // Instagram and Twitter are also supported in the links!
};

// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineering Intern, Infrastructure",
      company: "Adobe",
      companylogo: require("./assets/images/adobe.png"),
      date: "Jul 2021 – Oct 2021",
      colorcc: "#ED2224",
      descBullets: [
        "Work as a Software Engineering Intern in the infrastructure team for the payment platform.",
      ],
      url: "https://www.adobe.com"
    },
    {
      role: "Software Engineering Intern, Infrastructure",
      company: "NVIDIA",
      companylogo: require("./assets/images/nv.png"),
      date: "Apr 2021 – Jul 2021",
      colorcc: "#76b900",
      descBullets: [
        "Work as a Software Engineering Intern in Drive Analysis under the AI Infrastructure team for Autonomous Vehicles.",
          "Build supporting infrastructures and event-tracing systems for debugging on-car and in-simulation AI-driven autonomous driving.",
          "Design and build infrastructures and microservices that help index, mine, transform, and compose PB-sized deep learning datasets in Golang-based gRPC, Django, Python, and Bokeh.",
      ],
      url: "https://www.nvidia.com/en-us/"
    },
    {
      role: "Director of Engineering & Co-Founder",
      company: "croftery",
      companylogo: require("./assets/images/cf.jpg"),
      date: "Aug 2020 – present",
      descBullets: [
        "Create a platform to connect cottage businesses and certified home bakers with local customers.",
        "Work with other developers to build the web/iOS/Android application on the Google Cloud Platform, using React, Kart, Flutter, FlutterFire, FirebaseAuth, and Golang with Cloud Functions, Firebase, and Cloud Firestore.",
      ],
      colorcc: "#000000",
      url: "https://www.linkedin.com/company/cottage-us/"
    },
    {
      role: "Head Teaching Assistant",
      company: "UW CSE",
      companylogo: require("./assets/images/uwcse.jpg"),
      date: "Dec 2019 - present",
      colorcc: "#4b2e83",
      descBullets: [
        "CSE 414 - 20 WI",
        "CSE 414 - 20 SP",
        "CSE 344 - 20 SU",
        "CSE 414 - 20 AU",
          "CSE 414 - 21 WI",
          "CSE D 514 - 21 SP",
        "CSE 344 - 21 SU"
      ],
    },
    {
      role: "Research Assistant",
      company: "UW BioE",
      companylogo: require("./assets/images/bioe.jpg"),
      date: "Sep 2020 - present",
      colorcc: "#4b2e83",
      descBullets: [
        "Work with Dr. Joseph Hellerstein and researchers in Dr. Sauro's Predictive Sys-Bio Lab to develop software tools for model building in System Biology.",
        "Create SBviper, a python package for testing SBML models in System Biology.",
        "Contribute to the SimpleSBML project, a software package for constructing biological models without interacting directly with the libSBML package.",
        "Current research focuses on developing software programs for testing dynamical systems that do not just limit to the System Biology field.",
      ],
    },
    {
      role: "Research Software Engineering Intern",
      company: "eScience Institute",
      companylogo: require("./assets/images/esc.jpg"),
      date: "Jul 2020 – Oct 2020",
      descBullets: [
        "Develop software tools to improve the scalability and robustness of biological models.",
        "Create the static and dynamic testing module in python for system biology models in SBML format.",
        "Paper accepted and presented at the ISGSB conference."
      ],
      colorcc: "#ffffff",
      url: "https://escience.washington.edu"
    },
    {
      role: "Undergraduate Research Assistant",
      company: "UW GEMSEC",
      companylogo: require("./assets/images/gemsec.png"),
      date: "Sep 2019 - Oct 2020",
      descBullets: [
          "Work with Dr. Mehmet Sarikaya and Jacob Rodriguez on developing computational methods for identifying the similarities within biological structures.",
          "Develop a multi-thread optimization to the Needleman–Wunsch algorithm."
      ],
      colorcc: "lightgreen",
      url: "http://www.uwgemsec.com"
    },
    {
      role: "Technology Consultant",
      company: "Academic Technologies, University of Washington",
      companylogo: require("./assets/images/uw.jpg"),
      date: "June 2019 - Jul 2020",
      descBullets: [
          "Assist UW students, faculty, and staff with software problems on personal computers."
      ],
      colorcc: "#4b2e83",
      url: "https://www.cte.uw.edu/academictechnologies/"
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */
const openSource = {
  githubConvertedToken: "28ca5cbdd98a83cc55ca7e074e92d4eef9bac2ea",
  githubUserName: "mastevb", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"false" // Set true or false to show Contact profile using Github, defaults to false
};

const educExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "M.S. in Computer Science & Engineering",
      company: "U of Washington, Seattle",
      companylogo: require("./assets/images/uwcse.jpg"),
      date: "Mar 2021 - Jun 2022",
      descBullets: [
          "M.S. in Computer Science & Engineering (BS/MS).",
          "Advisor: Dr. Joseph Hellerstein."
      ],
      colorcc: "#4b2e83",
      url: "https://www.cs.washington.edu"
    },
    {
      role: "B.S. in Computer Science & Engineering",
      company: "U of Washington, Seattle",
      companylogo: require("./assets/images/uwcse.jpg"),
      date: "Sep 2017 - Mar 2021",
      descBullets: [
          "B.S. in Computer Science with Departmental Honors.",
          "Thesis title: Testing Dynamical Systems - an Application to Systems Biology.",
          "Advisor: Dr. Joseph Hellerstein.",
          "GPA: 3.91 / 4.00",
      ],
      colorcc: "#4b2e83",
      url: "https://www.cs.washington.edu"
    },
    {
      role: "High school diploma",
      company: "Beijing Haidian International School",
      companylogo: require("./assets/images/bjfles.png"),
      date: "2014 - 2017",
      descBullets: [
        emoji("I had a lot of fun in High School 😁")
      ],
      colorcc: "blue",
      url: "https://www.bjfles.com/?lang=en"
    },
    {
      role: "High school diploma",
      company: "Lake Shore High School",
      companylogo: require("./assets/images/lshs.png"),
      date: "2015 - 2016",
      descBullets: [
          "GPA: 3.93 / 4.00",
          "I played Sodapop in The Outsiders for the Drama club."
      ],
      colorcc: "red",
      url: "http://lshs.lakeshoreschools.org"
    },
  ]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "bochenma@cs.washington.edu"
};

export { greeting, socialMediaLinks, workExperiences, openSource, contactInfo, educExperiences};
